import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Artist } from "types/artist";

let cachedArtists: Artist[] | null = null;
let artistsInFlight: Promise<Artist[]> | null = null;

export const useArtists = (enabled: boolean = true) => {
  const [artists, setArtists] = React.useState<Artist[]>(() => cachedArtists || []);
  const [fetching, setFetching] = React.useState(enabled ? !cachedArtists : false);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    if (!enabled) return;
    if (cachedArtists) {
      setArtists(cachedArtists);
      setFetching(false);
      return;
    }
    (async () => {
      const data = await getArtists();
      if (data) setArtists(data);
    })();
  }, [enabled]);

  const getArtists = async (): Promise<Artist[] | null> => {
    if (cachedArtists) return cachedArtists;
    if (artistsInFlight) return artistsInFlight;
    try {
      setFetching(true);
      artistsInFlight = axios
        .get(
        `${API_BASE_URL}${API_URLS.Artists}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      )
        .then((r) => (r.data?.data || []) as Artist[]);
      const data = await artistsInFlight;
      cachedArtists = data;
      return data;
    } catch (e) {
      console.error(e);
      return null;
    } finally {
      artistsInFlight = null;
      setFetching(false);
    }
  };

  return { artists, fetching };
};
